export default "__VITE_PUBLIC_ASSET__cf01a6d4__"